import PropTypes from 'prop-types'
import React from 'react'
import AbteilungDialog from '#components/m/Versetzungsplan/AbteilungDialog'

export function AbteilungsEditDialog(props) {
  const {closeAbteilungDialog, selectedAbteilung, versetzungsplaene, azubis} = props

  return (
    <div className="abteilung_update">
      <AbteilungDialog
        closed={closeAbteilungDialog}
        versetzungsplaene={versetzungsplaene}
        userId={selectedAbteilung.userId}
        id={selectedAbteilung.id}
        from={new Date(selectedAbteilung.from)}
        to={new Date(selectedAbteilung.to)}
        abteilung={selectedAbteilung.abteilung}
        azubiId={selectedAbteilung.userId}
        azubis={azubis}
      />
    </div>
  )
}

AbteilungsEditDialog.propTypes = {
  azubis: PropTypes.array.isRequired,
  closeAbteilungDialog: PropTypes.any,
  selectedAbteilung: PropTypes.shape({
    abteilung: PropTypes.any,
    end: PropTypes.any,
    group: PropTypes.any,
    id: PropTypes.any,
    start: PropTypes.any,
  }),
  versetzungsplaene: PropTypes.any,
}

export default AbteilungsEditDialog
